import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const ParagraphIndentUnit = z.enum(["Pixels", "Rem", "Percent"]);

export const ParagraphIndentValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const ParagraphIndentTokenData = tokenAliasOrValue(ParagraphIndentValue);

export type ParagraphIndentUnit = z.infer<typeof ParagraphIndentUnit>;
export type ParagraphIndentValue = z.infer<typeof ParagraphIndentValue>;
export type ParagraphIndentTokenData = z.infer<typeof ParagraphIndentTokenData>;
